module.exports = __webpack_public_path__ + "efee7d70a7b12fda141153c8dd01ae3f.pdf";